__turbopack_context__.v({
  "cartButton": "eTRwca_cartButton",
  "cartOpen": "eTRwca_cartOpen",
  "wobbleBottom": "eTRwca_wobbleBottom",
});
